/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _ */

/*
 * Provides:
 *  mp.widgets.dropdowns.RoundedCheckbox
 *
 * Requires:
 *  mp.widgets.Dropdown
 *  mp.widgets.dropdowns.Checkbox
 *  mp.widgets.dropdowns.Rounded
 */

_.namespace(`mp.widgets.dropdowns`, function(module) {
  'use strict';

  function RoundedCheckbox() {
    this.class_name = `rounded_checkbox_dropdown`;
    this.label_class = Label;
    this.body_class = Body;
  }
  _.inherit(RoundedCheckbox, module.Checkbox);

  RoundedCheckbox.prototype.default_config = function() {
    return _.extend(RoundedCheckbox.superclass.default_config.call(this), {
      filterable: true,
    });
  };

  RoundedCheckbox.prototype.bindings = function() {
    RoundedCheckbox.superclass.bindings.apply(this, arguments);

    this.body.container.delegate(`.search_box`, `keydown`, _.bind(function(ev) {
      switch (ev.which) {
        case 27: // esc
          if (this.label.item && typeof(this.label.item) !== `string`) {
            this.body.select_item(this.label.item, true);
          }
          this.deactivate();
          break;
        case 9: // tab
          this.select_if_one_visible();
          break;
        case 13: // enter
          if (this.body.limited) {
            this.select_string();
          } else {
            this.select_if_one_visible();
          }
          break;
      }
    }, this));
  };

  RoundedCheckbox.prototype.select_if_one_visible = function() {
    //only lets enter select if filtered down to just one item
    if (this.body.visible().length === 1) {
      var visible = this.body.visible()[0];
      if (visible.selected) {
        visible.deselect();
      } else {
        this.select_item(visible);
      }
      this.body.deactivate();
    }
  };

  RoundedCheckbox.prototype.select_string = function() {
    this.select_item(this.body.select_string());
  };

  function Label() {
    this.class_name = `rounded_checkbox_label`;
  }
  _.inherit(Label, module.Checkbox.Label);

  Label.prototype.create = function(div, config) {
    // doing this so collapse functionality works
    this.title = $(`<div>`).addClass(`title`);
    this.arrow = $(`<div>`).addClass(`arrow`);

    Label.superclass.create.call(this, div, config);

    this.container.append(this.title, this.arrow);
    return this;
  };

  Label.prototype.styles = module.Rounded.Label.prototype.styles;


  function Body() {
    this.class_name = `rounded_checkbox_body`;
    this.item_class = Item;
  }
  _.inherit(Body, module.Checkbox.Body);

  Body.prototype.styles = module.Rounded.Body.prototype.styles;
  Body.prototype.create = function(div, config) {
    Body.superclass.create.call(this, div, config);

    if (!this.config.collapse) {
      this.container.css(`min-width`, this.config.min_width + 38);
    }

    var search_container = $(`<div>`).addClass(`search_box_container`);
    this.search = $(`<input />`).addClass(`search_box`);

    this.content = $(`<div>`).addClass(`content`);

    if (this.config.filterable === true) {
      this.container.append(search_container.append(this.search));
    }

    this.container.append(this.content);

    this.appendTo = this.content;
    return this;
  };

  Body.prototype.bindings = function() {
    Body.superclass.bindings.apply(this, arguments);

    this.container.delegate(`.search_box`, `keyup`,
      _.bind(this.filter, this));
  };

  Body.prototype.visible = function() {
    var items = [];
    _.each(this.widgets, function(item) {
      if (item.container.is(`:visible`)) { items.push(item); }
    });
    return items;
  };

  // Given a query string, returns a filter predicate
  // against strings. Exposed and separate so we can export it.
  var filter_predicate_from_query = function(query) {
    var normed_query = query.toLowerCase();
    return function(check_string) {
      var normed_check = check_string.toLowerCase();
      return ((query.length === 1 && _.startsWith(normed_check, normed_query)) ||
                    (query.length !== 1 && _.includes(normed_check, normed_query)));
    };
  };

  Body.prototype.filter = function(ev, skip_select) {
    if (ev && _.include([9, 13, 38, 40], ev.which)) {
      // the above key codes are esc/enter/up/down
      ev.preventDefault();
      return;
    }

    var query = this.search.val();
    var predicate = filter_predicate_from_query(query);

    _.each(this.widgets, function(item) {
      var display_val = item.display_value;
      if ( predicate(display_val) ) {
        item.container.show();
      } else {
        item.container.hide();
      }
    });
  };

  Body.prototype.activate = function() {
    Body.superclass.activate.apply(this, arguments);

    this.scroll_to_selected();

    this.search.attr(`value`, ``).focus();
    this.filter(undefined, true);

    return this;
  };

  Body.prototype.scroll_to_selected = function() {
    var selected = this.selected();
    if (selected && !_.isArray(selected)) {
      this.appendTo.scrollTo(selected.container, {offset: {top: -10*selected.container.height()}});
    }
  };

  Body.prototype.select_item = function(item, skip_event) {
    Body.superclass.select_item.apply(this, arguments);

    this.scroll_to_selected();
  };

  Body.prototype.select_string = function() {
    var widget;
    var string = this.search.val();

    _.each(this.widgets, function(item) {
      if (item.display_value === string) {
        widget = item;
      }
    });

    if (!widget) {
      widget = new this.item_class().create(null, this.config).update(string);
      var index = _.sortedIndex(this.widgets, widget, this.comparator);
      this.insert(widget, index);
    }

    return widget;
  };

  Body.prototype.fill = function(items, limited) {
    this.limited = limited || false;
    return Body.superclass.fill.call(this, items);
  };

  RoundedCheckbox.filter_predicate_from_query = filter_predicate_from_query;

  function Item() {
    this.class_name = `rounded_checkbox_item`;
  }
  _.inherit(Item, module.Checkbox.Item);

  RoundedCheckbox.Label = Label;
  RoundedCheckbox.Body = Body;
  RoundedCheckbox.Item = Item;

  return {
    RoundedCheckbox,
  };
});

}.call(window));